module.exports = __webpack_public_path__ + "img/hikProduct.ef406f59.png";